import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactGroupService {

  constructor(
    private http: CustomHttpService
  ) { }



  getAllContactGroups(data: any): Observable<any> {
    return this.http.post(environment.getAllContactGroups, data);
  }

  createContact_group(data: any): Observable<any> {
    return this.http.post(environment.createContactGroup, data);
  }

  deleteContactsFromGroup(data: any): Observable<any> {
    return this.http.post(environment.deleteContactsFromGroup, data);
  }

  updateContact_group(data: any): Observable<any> {
    return this.http.post(environment.updateContactGroup, data);
  }

  getAllContactGroupList(data: any): Observable<any> {
    return this.http.post(environment.getAllContactGroupList, data);
  }

  getAllLeads(data: any): Observable<any> {
    return this.http.post(environment.getAllLeads, data);
  }

  createContactGroupList(data: any): Observable<any> {
    // if (environment.production) {
    //   return this.http.post(
    //     "https://dq2u3e33n77csuhxu4qp52mwea0exanr.lambda-url.us-east-1.on.aws/",
    //     data,
    //     {
    //       headers: {
    //         'Content-Type': 'application/json'  
    //       }
    //     }
    //   );
    // } else {
    //   return this.http.post(
    //     "https://7gp3cvmkblop7iwe6b37oqdjeu0tpdha.lambda-url.us-east-1.on.aws/",
    //     data,
    //     {
    //       headers: {
    //         'Content-Type': 'application/json'  
    //       }
    //     }
    //   );
    // }
    return this.http.post(environment.createContactGroupList, data);
  }

  deleteContactGroup(data: any): Observable<any> {
    return this.http.post(environment.deleteContactGroup, data);
  }

  deleteContactGroupList(data: any): Observable<any> {
    return this.http.post(environment.deleteContactGroupList, data);
  }

  getLeadId(data: any): Observable<any> {
    return this.http.post(environment.getLeadId, data);
  }


  getAllContactGroupListFromDynamoDB(data : any): Observable<any> {
      return this.http.post(environment.getContactsInDynamoDBGroup, data);
  }

  getContactsReportInDynamoDBGroup(data : any): Observable<any> {
      return this.http.post(environment.getContactsReportInDynamoDBGroup, data);
  }

  uploadContactCSV(data : any): Observable<any> {
   return this.http.post(environment.uploadContactsToGroup, data);
  }

  getAllContactGroupListColumns(data: any): Observable<any> {
    return this.http.post(environment.getAllContactGroupListColumns, data);
  }
}